import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employeePaymentTypes: [],
    employeePaymentTypesCount: 0,
    employeePaymentType: {},
    employeePaymentTypeSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getemployeePaymentTypes(state) {
      return state.employeePaymentTypes
    },
    getemployeePaymentTypesCount(state) {
      return state.employeePaymentTypesCount
    },
    getemployeePaymentType(state) {
      return state.employeePaymentType
    },
    getemployeePaymentTypeSaveStatus(state) {
      return state.employeePaymentTypeSave
    },
  },
  mutations: {
    EMPLOYEE_PAYMENT_TYPES_LIST(state, data) {
      state.employeePaymentTypes = data
    },
    EMPLOYEE_PAYMENT_TYPE_VIEW(state, data) {
      state.employeePaymentType = data
    },
    EMPLOYEE_PAYMENT_TYPES_COUNT(state, data) {
      state.employeePaymentTypesCount = data
    },
    EMPLOYEE_PAYMENT_TYPE_SAVE(state, data) {
      state.employeePaymentTypeSave = data
    },
  },
  actions: {
    employeePaymentTypesList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hrDefines/employee_payment_types', data)
        .then(response => {
          commit('EMPLOYEE_PAYMENT_TYPES_LIST', response.data.data)
          commit('EMPLOYEE_PAYMENT_TYPES_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    employeePaymentTypeView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'employee_payment_types.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hrDefines/employee_payment_types', data)
        .then(response => {
          commit('EMPLOYEE_PAYMENT_TYPE_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    employeePaymentTypeSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hrDefines/employee_payment_types/saveData', data)
        .then(response => {
          commit('EMPLOYEE_PAYMENT_TYPE_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
